module.exports = __webpack_public_path__ + "cb0fb946cf7703f3bd36b5d90be28d8d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg55.jpeg
// module id = 67
// module chunks = 0